import { stripHtml } from "string-strip-html";
import Player from "~features/media/player";
import { cx } from "~utils";

/**
 * Podcast player that intelligently switches between
 * custom and megaphone player
 *
 * @param {{
 *   mediaUrl: string,
 *   title: string,
 *   className?: string,
 * }}
 * @returns
 */
export default function PodcastPlayer({ mediaUrl, title, className }) {
  let isMegaphoneMedia = false;
  let isLegacyMedia = false;
  const playerHostname = "https://playlist.megaphone.fm/";
  const lightTheme = "&light=true&artwork=false";
  let url = new URL(mediaUrl);
  let id = "";
  const ariaLabelMessage = title
    ? `Player for podcast titled: ${stripHtml(title).result}`
    : "podcast player";

  if (url.hostname === "traffic.megaphone.fm") {
    id = url.pathname.split(/[\.|\/]/)[1];
    isMegaphoneMedia = true;
  }

  if (url.hostname === "static.scientificamerican.com") {
    isLegacyMedia = true;
  }

  return (
    <>
      <a name="playerAnchor" id="playerAnchor"></a>
      {isMegaphoneMedia && (
        <iframe
          frameBorder="0"
          height="200"
          scrolling="no"
          loading="lazy"
          src={playerHostname + "?e=" + id + lightTheme}
          width="100%"
          className={className}
          aria-label={ariaLabelMessage}
        ></iframe>
      )}
      {isLegacyMedia && <Player src={mediaUrl} title={title} className={className} />}
    </>
  );
}
